import { ORDER_STATUSES } from "@/api/order/_models/Order";
import type { OrderStatus } from "@/api/order/_models/Order";

/** The backend's status string → OrderStatus; a value the UI doesn't know yet reads as "Unknown". */
export const toOrderStatus = (value: string): OrderStatus => {
  const status = ORDER_STATUSES.find((known) => known === value);
  if (status) {
    return status;
  }
  return "Unknown";
};
